import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { isProtectedApiRequest } from './auth-config';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const apiBaseUrl = auth.getApiBaseUrl();

  if (!apiBaseUrl || !isProtectedApiRequest(req.url, apiBaseUrl)) {
    return next(req);
  }

  return from(auth.ensureValidToken()).pipe(
    switchMap((token) => {
      if (!token) {
        auth.handleUnauthorized(window.location.pathname);
        return throwError(() => new Error('Authentication required.'));
      }

      return next(
        req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        }),
      ).pipe(
        catchError((error: unknown) => {
          if (
            error instanceof HttpErrorResponse &&
            error.status === 401 &&
            !auth.isAuthenticated()
          ) {
            auth.handleUnauthorized(window.location.pathname);
          }

          return throwError(() => error);
        }),
      );
    }),
  );
};
